module.exports = __webpack_public_path__ + "img/poly-5.c99ffdc9.png";